import HeaderPage from '../../Components/Header/Header'
import { Border, MainBody } from '../Main/Main-Styled'
import NendoStoreEx from '../../images/NendoStoreEx.png'
import foggModel from '../../images/foggModel.png'
import hookModel from '../../images/hookModel.png'
import persona2Ex from '../../images/persona2Ex.png'
import sociodem2 from '../../images/sociodem2.png'
import jornadaUsuario from '../../images/jornadaUsuario.png'
import {
  ContainerDesc,
  ContainerStyled,
  ContainerStyledImgs,
  IframeStyled
} from './Projeto2-Styled'
import FooterPage from '../../Components/Footer/Footer'
import sociodeMobile2 from '../../images/sociodeMobile2.png'
function Projeto2() {
  return (
    <>
      <HeaderPage />

      <MainBody>
        <ContainerStyled>
          <div>
            <h1>NendoStore</h1>
            <h2>Resumo</h2>

            <p>
              O projeto desenvolvido para a pós-graduação em User Experience na
              Belas Artes.
            </p>
            <p>
              A prototipagem avançada de interface para um e-commerce de
              Nendoroids tem como objetivo desenvolver uma experiência de
              usuário intuitiva, atrativa e eficiente, focada no público
              colecionador e fã de cultura pop.
            </p>
            <div>
              <span>
                Papel: <p>UI Designer</p>
              </span>
            </div>
            <div className="mobileEx">
              <img src={NendoStoreEx} alt="" />
            </div>
          </div>
          <div className="desktopEx">
            <img src={NendoStoreEx} alt="" />
          </div>
        </ContainerStyled>
        <ContainerDesc>
          <div className="problemaDesc">
            <h2>O problema</h2>

            <p>
              A plataforma criada apresenta uma experiência de compra rasa e
              pouco envolvente. As páginas são simplificadas, sem destaque para
              detalhes importantes e com design persuasivo mal aplicado. Isso
              prejudica a tomada de decisão de compra e o senso de imersão que
              esse tipo de colecionável costuma provocar no público-alvo.
            </p>
          </div>
          <div className="analiseCards">
            <article className="analysisCard">
              <h3>Modelo de Comportamento de Fogg</h3>

              <p>
                Há quebra no elemento de gatilho. Enquanto o usuário tem a
                motivação para comprar um item colecionável e a plataforma é
                simples de utilizar, não há gatilhos eficientes para encorajar
                os usuários a comprarem.
              </p>

              <img src={foggModel} alt="Modelo de Comportamento de Fogg" />
            </article>

            <article className="analysisCard">
              <h3>Modelo Hook</h3>

              <p>
                Há quebra no elemento de investimento, no qual faltam ações
                dentro da plataforma que levem os usuários a retornarem e
                utilizarem continuamente.
              </p>

              <img src={hookModel} alt="Modelo Hook" />
            </article>
          </div>
          <h2>Persona</h2>
          <ContainerStyledImgs>
            <div>
              <img src={persona2Ex} alt="" />
            </div>

            <div>
              <img className="desktopSocio" src={sociodem2} alt="" />
              <img className="mobileSocio" src={sociodeMobile2} alt="" />
            </div>
          </ContainerStyledImgs>
        </ContainerDesc>
        <ContainerDesc>
          <div className="JornadaUsuario">
            <h2>Jornada do Usuário</h2>
            <img
              src={jornadaUsuario}
              alt="Jornada do usuário do projeto NendoStore"
            />
          </div>
        </ContainerDesc>
        <ContainerDesc>
          <h2>A proposta</h2>

          <p>
            Visando os princípios do modelo Fogg e modelo Hook, a proposta
            sugerida visaria uma jornada mais envolvente e personalizada para o
            público-alvo, que valoriza o investimento emocional do colecionador
            e o convida a voltar a plataforma. O protótipo também conta com
            carrinho funcional, filtragem por categorias e modos claro e escuro.
          </p>
          <IframeStyled>
            <iframe src="https://embed.figma.com/proto/CosW9Jor6TAo6wTja4sPeq/E-commerce?node-id=488-639&viewport=645%2C422%2C0.25&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=488%3A639&page-id=488%3A637&embed-host=share"></iframe>
          </IframeStyled>
        </ContainerDesc>
        <ContainerDesc>
          <h2>Conclusão</h2>

          <p>
            Com isso, o e-commerce deixaria de ser apenas um canal de venda e se
            torna um ambiente interativo, promovendo engajamento duradouro,
            satisfação e fidelização. Ao integrar elementos que estimulam o
            engajamento contínuo e reforçam o vínculo emocional com o
            colecionador, a plataforma contribui para a construção de relações
            mais duradouras. Além disso, a prototipagem avançada, ao simular
            funcionalidades reais, torna a experiência mais atrativa e imersiva
            para os usuários.
          </p>
        </ContainerDesc>
      </MainBody>
      <Border style={{ marginTop: '64px' }} />
      <FooterPage />
    </>
  )
}

export default Projeto2
